<template>
	<div>
		url={{url}}
	</div>
</template>
<script>
	export default {
		data() {
			return {
				url:''
			}
		},
		mounted() {
			this.url=window.location.href
			// this.$loading('用户异常...');
		},
	}
</script>

<style lang="less" scoped="scoped"></style>


// WEBPACK FOOTER //
// src/views/error.vue